export default __webpack_public_path__ + "static/media/MP0048.5bfc6200.jpg";